import axios from "axios"
import { useDefaultAttachmentsApiForControllerRoute } from "."
import { useSuspenseQueryGet } from "../typed-client/hooks/use-suspense-query-get"

export function usePersonProfilePictureUrlWithAttachmentIdQuery(
  personId: number,
  size?: number | undefined
): string | undefined {
  const { data: attachmentId } = useSuspenseQueryGet(
    "/api/persons/attachments/get-profile-picture-id",
    { personId },
    { staleTime: 1000 * 60 }
  )

  const personApi = useDefaultAttachmentsApiForControllerRoute("persons")

  return attachmentId
    ? personApi.getThumbnailUrl(attachmentId, personId, size ?? 64, false)
    : undefined
}

export function usePersonAttachmentApi() {
  const defaultAPI = useDefaultAttachmentsApiForControllerRoute("persons")

  return {
    ...defaultAPI,
    getProfilePictureUrlForPerson: function (
      personId: number,
      size?: number | undefined
    ) {
      return `${defaultAPI.baseUrl}/get-profile-picture?personId=${personId}${
        size ? "&thumbnailSize=" + size : ""
      }`
    },
    addProfilePictureForPerson: function (file: File, personId: number) {
      const formData = new FormData()
      formData.append("file", file, file.name)

      return axios.post(
        `${defaultAPI.baseUrl}/set-profile-picture?personId=${personId}`,
        formData
      )
    },
  }
}
